import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export class BreadCrumbBmL10n {
  public static career = _('breadcrumb.bm.career');
  public static directory = _('breadcrumb.bm.directory');
  public static home = _('breadcrumb.bm.home');
  public static network = _('breadcrumb.bm.network');
  public static qualification = _('breadcrumb.bm.qualification');
}
